import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-settings-shell',
  standalone: false,
  templateUrl: './settings-shell.html',
  styleUrl: './settings-shell.scss',
})
export class SettingsShellComponent {
  @Input() pretitle = 'Configuration';
  @Input() title = 'Settings';
  @Input() formId: string | null = null;
  @Input() pending = false;
  @Input() saveLabel = 'Save Settings';
}
